import { defineStore } from "pinia";
import { setStore, getStore } from "@/util/store.js";
import { getSysOption,getBusoption,getBusOptionTree} from "@/api/system/option";

/**
 * import { systemStore } from "@/store/system";
 * setup() {
    const system_store = systemStore();
    return {
      system_store,
    };
  },
  this.system_store.XXXX(XXXX);
*/

export const systemStore = defineStore("system", {
  state: () => ({
    titleName:
      getStore({
        name: "titleName",
      }) || "", //标题名称
  }),
  getters: {},
  actions: {
    setTitleName(name) {
      setStore({
        name: "titleName",
        content: name,
      });
      this.titleName = name;
      document.title = name;
    },
    setSysOptions(data) {
      //获取系统字典
      let max = 3;
      return new Promise((resolve, reject) => {
        //优化获取不到的问题
        (function run(shu) {
          if (shu > max) {
            reject();
            return;
          }
          getSysOption(data)
            .then((res) => {
              resolve(res.data.data);
            })
            .catch((err) => {
              if (!(err && err.toString && err.toString().includes("401"))) {
                run(shu + 1);
              }
            });
        })(0);
      });
    },
    setBusoptions(data) {
      //获取业务字典
      //bus_dict
      // this.$store.dispatch('setBusoptions','REGION').then((res)=>{
      // });
      let max = 3;
      return new Promise((resolve, reject) => {
          
           (function run(shu){
                if(shu>max){
                  reject();
                  return
                }
                getBusoption(data).then(res=>{
                  resolve(res.data.data)
                }).catch(err=>{
                  
             
                  // 通过字符串匹配401，不再重试
                  if (!(err && err.toString && err.toString().includes("401"))) {
                    run(shu + 1);
                  }

                })
            })(0)
          })
    },
    setBusTreeOptions(data) {
      //获取业务字典树
      return new Promise((resolve, reject) => {
        getBusOptionTree(data)
          .then((res) => {
            resolve(res.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
});
